module.exports = __webpack_public_path__ + "img/phone-screen-cn.d14c20bb.png";